import React from 'react';

export const LayoutRightIcon = () => (
  <svg width="146" height="88" viewBox="0 0 146 88" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_740_26167)">
      <rect width="146" height="88" rx="4" fill="black" />
      <path
        d="M140.717 5H112.656C111.568 5 110.687 6.03681 110.687 7.31579V79.6842C110.687 80.9632 111.568 82 112.656 82H140.717C141.805 82 142.687 80.9632 142.687 79.6842V7.31579C142.687 6.03681 141.805 5 140.717 5Z"
        fill="#A2A4FF"
        fillOpacity="0.3"
      />
      <path
        d="M104.74 62.9159H5.94667C4.87155 62.9159 4 63.6523 4 64.5608V80.1869C4 81.0954 4.87155 81.8318 5.94667 81.8318H104.74C105.815 81.8318 106.687 81.0954 106.687 80.1869V64.5608C106.687 63.6523 105.815 62.9159 104.74 62.9159Z"
        fill="#211E27"
      />
      <path
        d="M8.86678 65.7944C8.86678 65.1131 8.21311 64.5608 7.40678 64.5608C6.60044 64.5608 5.94678 65.1131 5.94678 65.7944C5.94678 66.4758 6.60044 67.0281 7.40678 67.0281C8.21311 67.0281 8.86678 66.4758 8.86678 65.7944Z"
        fill="#100F12"
      />
      <path
        d="M26.5815 64.5608H12.2735C11.4671 64.5608 10.8135 65.1131 10.8135 65.7944C10.8135 66.4758 11.4671 67.0281 12.2735 67.0281H26.5815C27.3878 67.0281 28.0415 66.4758 28.0415 65.7944C28.0415 65.1131 27.3878 64.5608 26.5815 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M45.7558 64.5608H31.4478C30.6415 64.5608 29.9878 65.1131 29.9878 65.7944C29.9878 66.4758 30.6415 67.0281 31.4478 67.0281H45.7558C46.5621 67.0281 47.2158 66.4758 47.2158 65.7944C47.2158 65.1131 46.5621 64.5608 45.7558 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M64.9306 64.5608H50.6226C49.8163 64.5608 49.1626 65.1131 49.1626 65.7944C49.1626 66.4758 49.8163 67.0281 50.6226 67.0281H64.9306C65.7369 67.0281 66.3906 66.4758 66.3906 65.7944C66.3906 65.1131 65.7369 64.5608 64.9306 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M84.1054 64.5608H69.7974C68.9911 64.5608 68.3374 65.1131 68.3374 65.7944C68.3374 66.4758 68.9911 67.0281 69.7974 67.0281H84.1054C84.9117 67.0281 85.5654 66.4758 85.5654 65.7944C85.5654 65.1131 84.9117 64.5608 84.1054 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M103.28 64.5608H88.9722C88.1659 64.5608 87.5122 65.1131 87.5122 65.7944C87.5122 66.4758 88.1659 67.0281 88.9722 67.0281H103.28C104.087 67.0281 104.74 66.4758 104.74 65.7944C104.74 65.1131 104.087 64.5608 103.28 64.5608Z"
        fill="#100F12"
      />
      <path
        d="M8.86678 70.1808C8.86678 69.4995 8.21311 68.9471 7.40678 68.9471C6.60044 68.9471 5.94678 69.4995 5.94678 70.1808C5.94678 70.8621 6.60044 71.4144 7.40678 71.4144C8.21311 71.4144 8.86678 70.8621 8.86678 70.1808Z"
        fill="#100F12"
      />
      <path
        d="M26.5815 68.9471H12.2735C11.4671 68.9471 10.8135 69.4995 10.8135 70.1808C10.8135 70.8621 11.4671 71.4144 12.2735 71.4144H26.5815C27.3878 71.4144 28.0415 70.8621 28.0415 70.1808C28.0415 69.4995 27.3878 68.9471 26.5815 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M45.7558 68.9471H31.4478C30.6415 68.9471 29.9878 69.4995 29.9878 70.1808C29.9878 70.8621 30.6415 71.4144 31.4478 71.4144H45.7558C46.5621 71.4144 47.2158 70.8621 47.2158 70.1808C47.2158 69.4995 46.5621 68.9471 45.7558 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M64.9306 68.9471H50.6226C49.8163 68.9471 49.1626 69.4995 49.1626 70.1808C49.1626 70.8621 49.8163 71.4144 50.6226 71.4144H64.9306C65.7369 71.4144 66.3906 70.8621 66.3906 70.1808C66.3906 69.4995 65.7369 68.9471 64.9306 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M84.1054 68.9471H69.7974C68.9911 68.9471 68.3374 69.4995 68.3374 70.1808C68.3374 70.8621 68.9911 71.4144 69.7974 71.4144H84.1054C84.9117 71.4144 85.5654 70.8621 85.5654 70.1808C85.5654 69.4995 84.9117 68.9471 84.1054 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M103.28 68.9471H88.9722C88.1659 68.9471 87.5122 69.4995 87.5122 70.1808C87.5122 70.8621 88.1659 71.4144 88.9722 71.4144H103.28C104.087 71.4144 104.74 70.8621 104.74 70.1808C104.74 69.4995 104.087 68.9471 103.28 68.9471Z"
        fill="#100F12"
      />
      <path
        d="M8.86678 74.5668C8.86678 73.8855 8.21311 73.3332 7.40678 73.3332C6.60044 73.3332 5.94678 73.8855 5.94678 74.5668C5.94678 75.2482 6.60044 75.8005 7.40678 75.8005C8.21311 75.8005 8.86678 75.2482 8.86678 74.5668Z"
        fill="#100F12"
      />
      <path
        d="M26.5815 73.3332H12.2735C11.4671 73.3332 10.8135 73.8855 10.8135 74.5668C10.8135 75.2482 11.4671 75.8005 12.2735 75.8005H26.5815C27.3878 75.8005 28.0415 75.2482 28.0415 74.5668C28.0415 73.8855 27.3878 73.3332 26.5815 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M45.7558 73.3333H31.4478C30.6415 73.3333 29.9878 73.8856 29.9878 74.5669C29.9878 75.2482 30.6415 75.8005 31.4478 75.8005H45.7558C46.5621 75.8005 47.2158 75.2482 47.2158 74.5669C47.2158 73.8856 46.5621 73.3333 45.7558 73.3333Z"
        fill="#100F12"
      />
      <path
        d="M64.9306 73.3332H50.6226C49.8163 73.3332 49.1626 73.8855 49.1626 74.5668C49.1626 75.2482 49.8163 75.8005 50.6226 75.8005H64.9306C65.7369 75.8005 66.3906 75.2482 66.3906 74.5668C66.3906 73.8855 65.7369 73.3332 64.9306 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M84.1054 73.3332H69.7974C68.9911 73.3332 68.3374 73.8855 68.3374 74.5668C68.3374 75.2482 68.9911 75.8005 69.7974 75.8005H84.1054C84.9117 75.8005 85.5654 75.2482 85.5654 74.5668C85.5654 73.8855 84.9117 73.3332 84.1054 73.3332Z"
        fill="#100F12"
      />
      <path
        d="M103.28 73.3333H88.9722C88.1659 73.3333 87.5122 73.8856 87.5122 74.5669C87.5122 75.2482 88.1659 75.8005 88.9722 75.8005H103.28C104.087 75.8005 104.74 75.2482 104.74 74.5669C104.74 73.8856 104.087 73.3333 103.28 73.3333Z"
        fill="#100F12"
      />
      <path
        d="M8.86678 78.9532C8.86678 78.2719 8.21311 77.7196 7.40678 77.7196C6.60044 77.7196 5.94678 78.2719 5.94678 78.9532C5.94678 79.6346 6.60044 80.1869 7.40678 80.1869C8.21311 80.1869 8.86678 79.6346 8.86678 78.9532Z"
        fill="#100F12"
      />
      <path
        d="M26.5815 77.7196H12.2735C11.4671 77.7196 10.8135 78.2719 10.8135 78.9532C10.8135 79.6346 11.4671 80.1869 12.2735 80.1869H26.5815C27.3878 80.1869 28.0415 79.6346 28.0415 78.9532C28.0415 78.2719 27.3878 77.7196 26.5815 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M45.7558 77.7196H31.4478C30.6415 77.7196 29.9878 78.2719 29.9878 78.9533C29.9878 79.6346 30.6415 80.1869 31.4478 80.1869H45.7558C46.5621 80.1869 47.2158 79.6346 47.2158 78.9533C47.2158 78.2719 46.5621 77.7196 45.7558 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M64.9306 77.7196H50.6226C49.8163 77.7196 49.1626 78.2719 49.1626 78.9532C49.1626 79.6346 49.8163 80.1869 50.6226 80.1869H64.9306C65.7369 80.1869 66.3906 79.6346 66.3906 78.9532C66.3906 78.2719 65.7369 77.7196 64.9306 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M84.1054 77.7196H69.7974C68.9911 77.7196 68.3374 78.2719 68.3374 78.9532C68.3374 79.6346 68.9911 80.1869 69.7974 80.1869H84.1054C84.9117 80.1869 85.5654 79.6346 85.5654 78.9532C85.5654 78.2719 84.9117 77.7196 84.1054 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M103.28 77.7196H88.9722C88.1659 77.7196 87.5122 78.2719 87.5122 78.9533C87.5122 79.6346 88.1659 80.1869 88.9722 80.1869H103.28C104.087 80.1869 104.74 79.6346 104.74 78.9533C104.74 78.2719 104.087 77.7196 103.28 77.7196Z"
        fill="#100F12"
      />
      <path
        d="M104.74 4.93457H5.94667C4.87155 4.93457 4 5.671 4 6.57943V57.9813C4 58.8897 4.87155 59.6262 5.94667 59.6262H104.74C105.815 59.6262 106.687 58.8897 106.687 57.9813V6.57943C106.687 5.671 105.815 4.93457 104.74 4.93457Z"
        fill="#211E27"
      />
      <path
        d="M11.7866 53.0467L35.0946 32.6995L45.9965 43.2335L74.4771 18.3706L81.8958 26.3581L98.8999 11.514"
        stroke="#66BB6A"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
